import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import * as actions from '../../actions';
import { DEFAULT_NOTIFICATION_FILTER } from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './NotificationsPopover.pcss';
const ClearFiltersButton = ({ currentView })=>{
    const setNotificationFilterParams = useAction(actions.setNotificationFilterParams, DEFAULT_NOTIFICATION_FILTER);
    const notificationsFilter = useSelector(selectors.notificationsFilter);
    const isClean = isEqual(omit(notificationsFilter, 'limit'), omit(DEFAULT_NOTIFICATION_FILTER, 'limit'));
    if (isClean || currentView !== 'List') return null;
    return /*#__PURE__*/ _jsx(Button, {
        id: "notifications-clear-filters-btn",
        type: "button",
        styleModifier: "secondary",
        className: cn(styles.notifications__clearFiltersBtn, 'btn--sm btn--transparent'),
        labelMessage: messages.buttons.clear,
        onClick: setNotificationFilterParams
    });
};
export default ClearFiltersButton;
